// Recovered compiled webpack factory 24553. Edit this function expression; run npm run build.
(e, t) => {
  "use strict";
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    !(function (e, t) {
      for (var r in t) Object.defineProperty(e, r, { enumerable: !0, get: t[r] });
    })(t, {
      BailoutToCSRError: function () {
        return n;
      },
      isBailoutToCSRError: function () {
        return a;
      },
    }));
  let r = "BAILOUT_TO_CLIENT_SIDE_RENDERING";
  class n extends Error {
    constructor(e) {
      (super("Bail out to client-side rendering: " + e), (this.reason = e), (this.digest = r));
    }
  }
  function a(e) {
    return "object" == typeof e && null !== e && "digest" in e && e.digest === r;
  }
}
